"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoQueue = undefined;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoQueue = exports.VideoQueue = function () {
  function VideoQueue() {
    (0, _classCallCheck3.default)(this, VideoQueue);

    this.que = [];
    this.dummyVideo = { idx: -1, isVisible: function isVisible() {
        return false;
      } };
    this.video = this.dummyVideo;
  }

  (0, _createClass3.default)(VideoQueue, [{
    key: "current",
    value: function current() {
      return this.video.idx;
    }
  }, {
    key: "isCurrentVideoVisible",
    value: function isCurrentVideoVisible() {
      return this.video.isVisible();
    }
  }, {
    key: "next",
    value: function next() {
      if (this.que.length === 0) {
        return null;
      }
      var i = this.que.indexOf(this.video);
      var nextVideo = this.nextVisibleVideo(i + 1);

      this.video = nextVideo;
      return this.video.idx;
    }
  }, {
    key: "nextVisibleVideo",
    value: function nextVisibleVideo(j) {
      var len = this.que.length;
      var queIndex = void 0;
      for (var i = 0; i < len; i++) {
        queIndex = (i + j) % len;
        if (this.que[queIndex].isVisible()) {
          break;
        }
      }
      return this.que[queIndex] && this.que[queIndex].isVisible() ? this.que[queIndex] : this.dummyVideo;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.que.length === 0;
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      if (this.isEmpty()) {
        this.video = item;
      }
      this.que.push(item);
    }
  }, {
    key: "removeItem",
    value: function removeItem(id) {
      this.que = this.que.filter(function (element) {
        return element.idx !== id;
      });
      if (this.isEmpty()) {
        this.video = this.dummyVideo;
      }
      this.video = this.nextVisibleVideo(0);
    }
  }]);
  return VideoQueue;
}();